import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=1d27e6e0"
import script from "./Step3.ts?vue&type=script&lang=ts&external"
export * from "./Step3.ts?vue&type=script&lang=ts&external"
import style0 from "./Step3.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports